export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_RO_RGB_blk_100317.a42e378b.svg";